export function modifyArrayIndex(arr, idx, changes) {
  if (idx >= arr.length)
    return arr;

  return [
    ...arr.slice(0, idx),
    {
      ...arr[idx],
      ...changes,
    },
    ...arr.slice(idx+1)
  ];
}

export function modifyArrayItem(arr, item_, changes) {
  const i = arr.findIndex(item => item === item_);
  if (i < 0)
    return arr;

  return modifyArrayIndex(arr, i, changes);
}

export function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function formatFieldName(s) {
  return s.split('_').map(w => capitalize(w)).join(' ');
}

// data is like: {a: 234, b: 325, ...}
export function formatPercent(data) {
  const sum = Object.values(data).reduce((acc, val) => acc + val, 0);
  return Object.keys(data).sort().map(key => {
    let pct = (100*data[key]/sum).toFixed(2);
    return `${key}: ${pct}%/${data[key]}`;
  }).join(', ');
}
